export default __webpack_public_path__ + "static/media/menu-1.a5e110b8.PNG";